// src/features/records/components/ShareDialog/components/NotifyTextarea.js

import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './NotifyTextarea.module.css';

const NotifyTextarea = ({
  notifyUsers = true,
  message = '',
  onMessageChange,
  disabled = false,
  className = '',
}) => {
  const { t } = useTranslation();

  // Always render to enable smooth expand/collapse animation
  return (
    <div className={`${styles.messageContainer} ${notifyUsers ? styles.active : ''} ${className}`}>
      <textarea
        value={message}
        onChange={(e) => onMessageChange(e.target.value)}
        placeholder={t("records.share.notify.message_placeholder", "Add a message (optional)")}
        disabled={disabled}
        className={styles.textarea}
        rows={3}
        maxLength={500}
        aria-label={t("records.share.notify.message_aria", "Optional message")}
      />
    </div>
  );
};

export default NotifyTextarea;
